// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"typeform-module--wrapper--3dLD_","powered":"typeform-module--powered--1dzhB","link":"typeform-module--link--1_gs5"};